<mat-spinner
    [diameter]="diameter"
    [mode]="mode"
    [value]="value"
>
</mat-spinner>